import {
  getTenantConfiguration,
  type TenantConfiguration,
} from '@/utils/tenant';

export const useTenantConfiguration = (): TenantConfiguration =>
  getTenantConfiguration();
